// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: JqZZnD7Dh0s
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import RadialSummary from "../../RadialSummary"; // plasmic-import: oyxikxJz0w/component
import ReturnCityOverviewButton from "../../ReturnCityOverviewButton"; // plasmic-import: uOdAuk8zpe/component
import ReturnToListOfCitiesButton from "../../ReturnToListOfCitiesButton"; // plasmic-import: Gm0oD2L2zL/component
import BrandName from "../../BrandName"; // plasmic-import: PvQCJPuBXG/component
import BrandsSummaryTitle from "../../BrandsSummaryTitle"; // plasmic-import: SG-G6MD1MQ/component
import CompanyDescriptionComp from "../../CompanyDescriptionComp"; // plasmic-import: mofKRyDpLo/component
import RadialChartCompanySentiment from "../../RadialChartCompanySentiment"; // plasmic-import: _wlGAge9eM/component
import SentimentsAnalyzed from "../../SentimentsAnalyzed"; // plasmic-import: 1En-QsN0bs/component
import BrandPerceptionBarChart from "../../BrandPerceptionBarChart"; // plasmic-import: NiQ0_jQVtY/component
import CallToActionBanner from "../../CallToActionBanner"; // plasmic-import: yhV9Z2-FHhl/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicBrandAnalysis.module.css"; // plasmic-import: JqZZnD7Dh0s/css
import screenshot13PngFBCyfq1Zsds from "./images/screenshot13Png.png"; // plasmic-import: fB-Cyfq1zsds/picture
import screenshot14PngKvncqgUngVew from "./images/screenshot14Png.png"; // plasmic-import: KvncqgUngVew/picture

createPlasmicElementProxy;

export const PlasmicBrandAnalysis__VariantProps = new Array();

export const PlasmicBrandAnalysis__ArgProps = new Array(
  "tweetLink",
  "cityAggReturnLink"
);

const $$ = {};

function PlasmicBrandAnalysis__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          cityAggReturnLink: `/global-rankings`
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <Stack__
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <NavBar2
            data-plasmic-name={"navBar2"}
            data-plasmic-override={overrides.navBar2}
            className={classNames("__wab_instance", sty.navBar2)}
          />

          <div
            data-plasmic-name={"titlesSection"}
            data-plasmic-override={overrides.titlesSection}
            className={classNames(projectcss.all, sty.titlesSection)}
          >
            <div className={classNames(projectcss.all, sty.columns__mKt1U)}>
              <div className={classNames(projectcss.all, sty.column__xIKhH)}>
                <div className={classNames(projectcss.all, sty.freeBox__csmAi)}>
                  <h1
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1__jOkFo
                    )}
                  >
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FFFFFF" }}
                      >
                        {"Consumer Experience Index"}
                      </span>
                    </React.Fragment>
                  </h1>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__vhiH
                    )}
                  >
                    {
                      "Basil Labs' Global Rankings analyzes millions of datapoints to quantify consumer sentiment of brands and cities across the world."
                    }
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"radialSummaryCol"}
                data-plasmic-override={overrides.radialSummaryCol}
                className={classNames(projectcss.all, sty.radialSummaryCol)}
              >
                <RadialSummary
                  data-plasmic-name={"radialSummary"}
                  data-plasmic-override={overrides.radialSummary}
                  cityH1={"Bostontestetstste etstsetsetset"}
                  className={classNames("__wab_instance", sty.radialSummary)}
                  leftAligned={
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : undefined
                  }
                  nobox={true}
                  notWrapped={true}
                  showButton={true}
                />
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"firstSection"}
            data-plasmic-override={overrides.firstSection}
            className={classNames(projectcss.all, sty.firstSection)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__xFFbg)}
            >
              <div className={classNames(projectcss.all, sty.column__l1Ll7)}>
                <div
                  data-plasmic-name={"returnOptions"}
                  data-plasmic-override={overrides.returnOptions}
                  className={classNames(projectcss.all, sty.returnOptions)}
                >
                  <ReturnCityOverviewButton
                    data-plasmic-name={"returnCityOverviewButton"}
                    data-plasmic-override={overrides.returnCityOverviewButton}
                    className={classNames(
                      "__wab_instance",
                      sty.returnCityOverviewButton
                    )}
                  />

                  <ReturnToListOfCitiesButton
                    data-plasmic-name={"returnToListOfCitiesButton"}
                    data-plasmic-override={overrides.returnToListOfCitiesButton}
                    className={classNames(
                      "__wab_instance",
                      sty.returnToListOfCitiesButton
                    )}
                  />
                </div>
                <div
                  data-plasmic-name={"brandList"}
                  data-plasmic-override={overrides.brandList}
                  className={classNames(projectcss.all, sty.brandList)}
                >
                  <div
                    data-plasmic-name={"brandTitle"}
                    data-plasmic-override={overrides.brandTitle}
                    className={classNames(projectcss.all, sty.brandTitle)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__k2Dyw)}
                    >
                      <h1
                        className={classNames(
                          projectcss.all,
                          projectcss.h1,
                          projectcss.__wab_text,
                          sty.h1__fWhf
                        )}
                      >
                        {"Brands"}
                      </h1>
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ergsl)}
                  >
                    <Stack__
                      as={"div"}
                      data-plasmic-name={"brandListCol"}
                      data-plasmic-override={overrides.brandListCol}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.brandListCol)}
                    >
                      <div
                        data-plasmic-name={"brand"}
                        data-plasmic-override={overrides.brand}
                        className={classNames(projectcss.all, sty.brand)}
                      >
                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName__xsRD
                          )}
                        />

                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName__llTp5
                          )}
                        />

                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName___98AM
                          )}
                        />

                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName__r4Yq0
                          )}
                        />

                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName__gz24
                          )}
                        />

                        <BrandName
                          className={classNames(
                            "__wab_instance",
                            sty.brandName__jpO0
                          )}
                        />
                      </div>
                    </Stack__>
                  </div>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.column___5YKaH)}>
                <div className={classNames(projectcss.all, sty.freeBox__ksxg5)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mpKa0)}
                  >
                    <div
                      data-plasmic-name={"brandDetailRight"}
                      data-plasmic-override={overrides.brandDetailRight}
                      className={classNames(
                        projectcss.all,
                        sty.brandDetailRight
                      )}
                    >
                      <BrandsSummaryTitle
                        data-plasmic-name={"brandsSummaryTitle"}
                        data-plasmic-override={overrides.brandsSummaryTitle}
                        brandName={"Mcdonalds"}
                        className={classNames(
                          "__wab_instance",
                          sty.brandsSummaryTitle
                        )}
                      />

                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__cu9VB
                        )}
                      >
                        <Stack__
                          as={"div"}
                          hasGap={true}
                          className={classNames(
                            projectcss.all,
                            sty.columns__zG7PF
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__p2Yb4
                            )}
                          >
                            <CompanyDescriptionComp
                              data-plasmic-name={"companyDescriptionComp"}
                              data-plasmic-override={
                                overrides.companyDescriptionComp
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.companyDescriptionComp
                              )}
                            />
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__efywb
                            )}
                          >
                            <div
                              data-plasmic-name={"radialAndDatapoints"}
                              data-plasmic-override={
                                overrides.radialAndDatapoints
                              }
                              className={classNames(
                                projectcss.all,
                                sty.radialAndDatapoints
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox__nW1H
                                )}
                              >
                                <RadialChartCompanySentiment
                                  data-plasmic-name={
                                    "radialChartCompanySentiment"
                                  }
                                  data-plasmic-override={
                                    overrides.radialChartCompanySentiment
                                  }
                                  className={classNames(
                                    "__wab_instance",
                                    sty.radialChartCompanySentiment
                                  )}
                                  radial={
                                    <PlasmicImg__
                                      alt={""}
                                      className={classNames(sty.img__rtNlc)}
                                      displayHeight={"auto"}
                                      displayMaxHeight={"none"}
                                      displayMaxWidth={"100%"}
                                      displayMinHeight={"0"}
                                      displayMinWidth={"0"}
                                      displayWidth={"auto"}
                                      loading={"lazy"}
                                      src={{
                                        src: screenshot13PngFBCyfq1Zsds,
                                        fullWidth: 506,
                                        fullHeight: 509,
                                        aspectRatio: undefined
                                      }}
                                    />
                                  }
                                />
                              </div>
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox__uVb4
                                )}
                              >
                                <SentimentsAnalyzed
                                  data-plasmic-name={"sentimentsAnalyzed"}
                                  data-plasmic-override={
                                    overrides.sentimentsAnalyzed
                                  }
                                  className={classNames(
                                    "__wab_instance",
                                    sty.sentimentsAnalyzed
                                  )}
                                />

                                <div
                                  className={classNames(
                                    projectcss.all,
                                    sty.freeBox__ymo48
                                  )}
                                >
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__otZfp
                                    )}
                                  >
                                    {"Avg. Sentiment By Topic"}
                                  </div>
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__np2Ef
                                    )}
                                  >
                                    {
                                      "Basil Labs' Global Rankings analyzes millions of datapoints collected from social media and review platforms to quantify consumer sentiment of brands and cities across the world."
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Stack__>
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__mIdzg
                        )}
                      >
                        <div
                          data-plasmic-name={"barChart"}
                          data-plasmic-override={overrides.barChart}
                          className={classNames(projectcss.all, sty.barChart)}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.columns__n6WUy
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.column__hpz3U
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__gyCrK
                                )}
                              >
                                {"Sentiment by Topic"}
                              </div>
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__fDvW
                                )}
                              >
                                {
                                  "The higher the bar, the most positively consumers discussed the topic. Different brands may have different topics depending on what their customers discussed online."
                                }
                              </div>
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text___8W5Bu
                                )}
                              >
                                {"Average Sentiment by Topic"}
                              </div>
                            </div>
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.column__wrdmh
                              )}
                            >
                              <BrandPerceptionBarChart
                                data-plasmic-name={"brandPerceptionBarChart"}
                                data-plasmic-override={
                                  overrides.brandPerceptionBarChart
                                }
                                className={classNames(
                                  "__wab_instance",
                                  sty.brandPerceptionBarChart
                                )}
                                sentimentBarChart={
                                  <PlasmicImg__
                                    alt={""}
                                    className={classNames(sty.img__pallF)}
                                    displayHeight={"auto"}
                                    displayMaxHeight={"none"}
                                    displayMaxWidth={"100%"}
                                    displayMinHeight={"0"}
                                    displayMinWidth={"0"}
                                    displayWidth={"auto"}
                                    loading={"lazy"}
                                    src={{
                                      src: screenshot14PngKvncqgUngVew,
                                      fullWidth: 617,
                                      fullHeight: 558,
                                      aspectRatio: undefined
                                    }}
                                  />
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Stack__>
          </div>
          <CallToActionBanner
            data-plasmic-name={"callToActionBanner"}
            data-plasmic-override={overrides.callToActionBanner}
            className={classNames("__wab_instance", sty.callToActionBanner)}
          />

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </Stack__>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar2",
    "titlesSection",
    "radialSummaryCol",
    "radialSummary",
    "firstSection",
    "returnOptions",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton",
    "brandList",
    "brandTitle",
    "brandListCol",
    "brand",
    "brandDetailRight",
    "brandsSummaryTitle",
    "companyDescriptionComp",
    "radialAndDatapoints",
    "radialChartCompanySentiment",
    "sentimentsAnalyzed",
    "barChart",
    "brandPerceptionBarChart",
    "callToActionBanner",
    "footer"
  ],

  navBar2: ["navBar2"],
  titlesSection: ["titlesSection", "radialSummaryCol", "radialSummary"],
  radialSummaryCol: ["radialSummaryCol", "radialSummary"],
  radialSummary: ["radialSummary"],
  firstSection: [
    "firstSection",
    "returnOptions",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton",
    "brandList",
    "brandTitle",
    "brandListCol",
    "brand",
    "brandDetailRight",
    "brandsSummaryTitle",
    "companyDescriptionComp",
    "radialAndDatapoints",
    "radialChartCompanySentiment",
    "sentimentsAnalyzed",
    "barChart",
    "brandPerceptionBarChart"
  ],

  returnOptions: [
    "returnOptions",
    "returnCityOverviewButton",
    "returnToListOfCitiesButton"
  ],

  returnCityOverviewButton: ["returnCityOverviewButton"],
  returnToListOfCitiesButton: ["returnToListOfCitiesButton"],
  brandList: ["brandList", "brandTitle", "brandListCol", "brand"],
  brandTitle: ["brandTitle"],
  brandListCol: ["brandListCol", "brand"],
  brand: ["brand"],
  brandDetailRight: [
    "brandDetailRight",
    "brandsSummaryTitle",
    "companyDescriptionComp",
    "radialAndDatapoints",
    "radialChartCompanySentiment",
    "sentimentsAnalyzed",
    "barChart",
    "brandPerceptionBarChart"
  ],

  brandsSummaryTitle: ["brandsSummaryTitle"],
  companyDescriptionComp: ["companyDescriptionComp"],
  radialAndDatapoints: [
    "radialAndDatapoints",
    "radialChartCompanySentiment",
    "sentimentsAnalyzed"
  ],

  radialChartCompanySentiment: ["radialChartCompanySentiment"],
  sentimentsAnalyzed: ["sentimentsAnalyzed"],
  barChart: ["barChart", "brandPerceptionBarChart"],
  brandPerceptionBarChart: ["brandPerceptionBarChart"],
  callToActionBanner: ["callToActionBanner"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBrandAnalysis__ArgProps,
          internalVariantPropNames: PlasmicBrandAnalysis__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBrandAnalysis__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBrandAnalysis";
  } else {
    func.displayName = `PlasmicBrandAnalysis.${nodeName}`;
  }
  return func;
}

export const PlasmicBrandAnalysis = Object.assign(
  // Top-level PlasmicBrandAnalysis renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    titlesSection: makeNodeComponent("titlesSection"),
    radialSummaryCol: makeNodeComponent("radialSummaryCol"),
    radialSummary: makeNodeComponent("radialSummary"),
    firstSection: makeNodeComponent("firstSection"),
    returnOptions: makeNodeComponent("returnOptions"),
    returnCityOverviewButton: makeNodeComponent("returnCityOverviewButton"),
    returnToListOfCitiesButton: makeNodeComponent("returnToListOfCitiesButton"),
    brandList: makeNodeComponent("brandList"),
    brandTitle: makeNodeComponent("brandTitle"),
    brandListCol: makeNodeComponent("brandListCol"),
    brand: makeNodeComponent("brand"),
    brandDetailRight: makeNodeComponent("brandDetailRight"),
    brandsSummaryTitle: makeNodeComponent("brandsSummaryTitle"),
    companyDescriptionComp: makeNodeComponent("companyDescriptionComp"),
    radialAndDatapoints: makeNodeComponent("radialAndDatapoints"),
    radialChartCompanySentiment: makeNodeComponent(
      "radialChartCompanySentiment"
    ),
    sentimentsAnalyzed: makeNodeComponent("sentimentsAnalyzed"),
    barChart: makeNodeComponent("barChart"),
    brandPerceptionBarChart: makeNodeComponent("brandPerceptionBarChart"),
    callToActionBanner: makeNodeComponent("callToActionBanner"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicBrandAnalysis
    internalVariantProps: PlasmicBrandAnalysis__VariantProps,
    internalArgProps: PlasmicBrandAnalysis__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs Brand Analysis",
      description:
        "A global index of retailers benchmarked by consumer experience",
      ogImageSrc:
        "https://site-assets.plasmic.app/a9c047168a332e71149b68af02fe575a.png",
      canonical: ""
    }
  }
);

export default PlasmicBrandAnalysis;
/* prettier-ignore-end */
